/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaMail: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="mail" viewBox="0 0 16 12">
      <path
        d="M15.3334 1.9887C15.3334 1.99536 15.3334 2.00203 15.3334 2.0087V10.0007C15.3334 11.102 14.4347 12.0007 13.3334 12.0007H2.66669C1.56535 12.0007 0.666687 11.102 0.666687 10.0007V2.0087C0.666687 2.00203 0.666687 1.99536 0.666687 1.9887C0.673354 0.892697 1.56935 3.05176e-05 2.66669 3.05176e-05H13.3334C14.4314 3.05176e-05 15.3274 0.89203 15.3334 1.9887ZM13.9287 1.7027C13.8187 1.4847 13.592 1.33336 13.3334 1.33336H2.66669C2.40802 1.33336 2.18135 1.4847 2.07135 1.7027L8.00002 5.8527L13.9287 1.7027ZM14 3.2807L8.38202 7.21336C8.15269 7.37403 7.84669 7.37403 7.61735 7.21336L1.99935 3.2807V10C1.99935 10.3654 2.30069 10.6667 2.66602 10.6667H13.3327C13.698 10.6667 13.9994 10.3654 13.9994 10V3.2807H14Z"
        fill="currentColor"
      ></path>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaMail)
